import React from "react";

const ALIGNMENT_MAPPING = {
  left: "justify-content-start",
  center: "justify-content-center",
  right: "justify-content-end",
}

export const Logo = ({ value, invoiceLogoStyle }) => { 
  if (!value) return null;

  if (invoiceLogoStyle?.display === 'none') return null

  let logoContainerClassName = `justify-content-end`
  let logoStyle = { maxHeight: 200 }

  if (ALIGNMENT_MAPPING[invoiceLogoStyle?.alignment]) {
    logoContainerClassName = ALIGNMENT_MAPPING[invoiceLogoStyle.alignment]
  }

  if (invoiceLogoStyle?.width) {
    logoStyle.width = invoiceLogoStyle?.width + 'px'
  }

  if (invoiceLogoStyle?.height) {
    logoStyle.height = invoiceLogoStyle?.height
  }

  return (
    <div className={`top row mb-2`}>
      {value && (
        <div className={`col-12 d-flex ${logoContainerClassName}`}>
          <img style={logoStyle} src={value} alt="logo" />
        </div>
      )}
    </div>
  );
};

export default Logo;
